import React from 'react';
import JoinTeamPage from '@artemis/containers/Teams/JoinTeamPage';
import { loadResourceSet } from '@artemis/store/resourceSet/slice';
import { getAnalyticsIdentity } from '@artemis/store/user/slice';
import commonStrings from '@artemis/utils/common-strings.json';

const JoinTeam = props => <JoinTeamPage {...props} />;

JoinTeam.getInitialProps = async ctx => {
  const { contentfulLocale, isServer, store } = ctx;
  if (isServer) {
    store.dispatch(
      loadResourceSet({
        name: ['invite', 'teams', ...commonStrings],
        locale: contentfulLocale,
      }),
    );
    // Required to get entity id from athena for analytics since
    // all requests are made on this page are from content-gateway
    store.dispatch(getAnalyticsIdentity());
  }
  return {};
};

export default JoinTeam;
